import React from 'react';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import classnames from 'classnames';
import SectionContainer from 'components/Containers/SectionContainer';
import { Button } from 'components/form/Button';
import { Link } from 'components/navigation/Link/Link';

const AccountChangeCreditFactorGrade = props => {
  return (
    <SectionContainer className="cmAlertsDetailsContainer notificationsAlertsDetails">
      <Row className="text-28 fontLatoNormal700 margB16 boxShadowMobileNotification">
        <Label type="H4 padb16">Change in Credit Factor Grade</Label>
      </Row>

      <Row>
        <FlexContainer column>
          <Label className="caption fontGray300">
            <FlexContainer alignItemsCenter>
              {`Reported on ${props.alertDetailsConfig?.date} to `}
              <div className="margR2"></div>
              <div
                className={classnames({
                  margTopN3: props.selectedAlertDetails?.alertProvider,
                })}
              >
                {
                  props?.bureauLogo[
                    props.selectedAlertDetails?.bureau ||
                      props.selectedAlertDetails?.alertProvider
                  ]
                }
              </div>
            </FlexContainer>
          </Label>
          <Label className="text-16 fontLatoNormal400 margt20">
            We’ve noticed some changes in your credit factors.
          </Label>
          <Label type="Body1" className="margT16 mBody-2">
            Take a look at these changes to help you understand your credit
            score better.
          </Label>
        </FlexContainer>
      </Row>
      <Row>
        <Link className="mformat100" to="/factors">
          <Button mrphType="primary">
            Explore what’s impacting your score
          </Button>
        </Link>
      </Row>
    </SectionContainer>
  );
};

export default AccountChangeCreditFactorGrade;
